import { world } from '../../languages';
import { AVAILABLE_WORLDS } from '../../languages/constants';

const showQualityBadge = (material?: Material): boolean =>
    world === AVAILABLE_WORLDS.DE && Boolean(material?.isHighQuality);

export default showQualityBadge;
